import { useEffect, useMemo, useState } from "react";

import type { Event } from "../types/models/event.model.type";
import { useAppSelector } from "./redux.hook";
import { selectUserEvents } from "../app/features/auth/auth.slice";

declare type Props = {
  restrictions: string[];
};

const usePermissions = ({ restrictions }: Props) => {
  const events = useAppSelector(selectUserEvents);
  const [isValidating, setIsValidating] = useState(true);
  const [permitted, setPermitted] = useState(false);

  useEffect(() => {
    const isValidAccess = () => {
      let hasAccess: boolean = false;
      if (events) {
        hasAccess = events!.some((event: Event) => restrictions.includes(event.url));
      }
      setIsValidating(false);
      return hasAccess;
    };
    setPermitted(isValidAccess());
  }, [events, restrictions, setPermitted]);

  return useMemo(() => ({ permitted, isValidating }), [permitted, isValidating]);
};

export default usePermissions;
